import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HttpClientModule} from '@angular/common/http';
import {BsModalService, ModalModule, BsDatepickerModule} from 'ngx-bootstrap';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DataTablesModule} from 'angular-datatables';
import {DateTimePickerModule} from 'ng-pick-datetime';
import {SharedModule} from '../../../_shared/shared.module';
import { ChartsModule } from 'ng2-charts';
import { CommonModule } from '@angular/common';
import { Daterangepicker } from 'ng2-daterangepicker';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { ReportsComponentModule } from '../../reports-component/reports-component.module';
import { TopContentDiscussComponent } from './top-content-discuss.component';
import { TopContentDiscussService } from './top-content-discuss.service';
import { NgxPaginationModule } from 'ngx-pagination';
const routes: Routes = [
  {
    path: '',
    component: TopContentDiscussComponent,
    data: {
      title: 'Báo cáo Top nội dung được thảo luận nhiều nhất'
    },
  }
];
@NgModule({
  imports: [
    ChartsModule,
    TabsModule,
    BsDatepickerModule.forRoot(),
    CommonModule,
    DataTablesModule,
    Daterangepicker,
    HttpClientModule,
    RouterModule.forChild(routes),
    AngularMultiSelectModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    ReportsComponentModule,
    NgxPaginationModule
  ],
  declarations: [TopContentDiscussComponent],
  providers: [TopContentDiscussService]
})
export class TopContentDiscussModule { }



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/top-content-discuss/top-content-discuss.module.ts